import { NotificationBaseViewModel, NotificationTypes } from "./notificationsApiSlice";

export function getNotificationUrl(notification: NotificationBaseViewModel) {
	switch (notification.notificationType) {
		case NotificationTypes.LessonAssigned:
			return `/lessons/${notification.lessonCodeName}`;
		case NotificationTypes.DueDate:
			return `/writing?promptId=${notification.promptId}`;
		case NotificationTypes.DueDateExceeded:
			return `/writing`;
		case NotificationTypes.PeerReview:
		case NotificationTypes.PeerReviewRequest:
			return `/reviews/${notification.draftPeerReviewId}`;
		case NotificationTypes.DraftFinalize:
		case NotificationTypes.DraftSubmit:
			return `/scoreReport?draftId=${notification.draftId}`;
		case NotificationTypes.NewMessage:
			return `/scoreReport?draftId=${notification.lastDraftId}`;
	}
	return `/home`;
}

export function getNotificationOptions(notification: NotificationBaseViewModel) {
	switch (notification.notificationType) {
		case NotificationTypes.DueDateExceeded:
			return {
				state: { expandedStatus: "not started", promptId: notification.promptId },
			};
		case NotificationTypes.NewMessage:
			return {
				state: { section: "EssayMessages" },
			};
	}
	return undefined;
}
